import { Alert, Snackbar, } from "@mui/material";
import {useSnackbar} from "../../contexts/SnackbarContext";


export default function CustomSnackBar() {
  const {snackbarMessage, handleSnackbarClose } = useSnackbar();

  return (
    <Snackbar
      style={{ marginBottom: '2em' }}
      open={snackbarMessage?.open}
      autoHideDuration={6000}
      onClose={handleSnackbarClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      sx={{ marginTop: '2.5em' }}
    >
      <Alert onClose={handleSnackbarClose} severity={snackbarMessage.type} sx={{ width: '100%' }}>{snackbarMessage.message}</Alert>
    </Snackbar>
  )

}
